const vueAskAQuestionModal = new Vue({
	name: 'vueAskAQuestionModal',
	el: '#vueAskAQuestionModal',
	data: {
		showAskAQuestionModal: false,
		question: {
			name: '',
			companyName: '',
			email: '',
			question: '',
			productId: GLOBAL.PRODUCT.ID,
		},
		response: {
			success: false,
			failed: false,
		},
	},
	mixins: [requestServiceMixin, contactServiceMixin, customValidationMixin, modalsMixin, generalMixin],
	validations: {
		question: {
			name: {
				required,
			},
			email: {
				required,
				email,
			},
			question: {
				required,
			},
		},
	},
	methods: {
		open: function () {
			const vm = this;
			vm.askAQuestionModal().show();
		},
		close: function () {
			const vm = this;
			vm.askAQuestionModal().hide();
			vm.reset();
		},
		reset: function () {
			const vm = this;

			vm.question = {
				name: '',
				companyName: '',
				email: '',
				question: '',
				productId: GLOBAL.PRODUCT.ID,
			};

			vm.response = {
				success: false,
				failed: false,
			};

			vm.$v.$reset();
		},
		submitAskAQuestion: async function () {
			const vm = this;
			vm.$v.$reset();
			vm.generalError = '';
			vm.$v.$touch();

			if (vm.$v.$invalid) {
				vm.submitError();

				return;
			}

			vm.askAQuestion(vm.question).then(function (response) {
				if (!response) return;

				const content = response.data.content;

				if (content.errors !== null) {
					vm.response.failed = true;
				} else {
					vm.response.success = true;
				}
			});
		},
	},
});
